/** Journey stages used by breadcrumb component */
export type Step = 'tickets' | 'results' | 'details' | 'confirmation';
